var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('session-details',{attrs:{"dialog":true,"session-id":_vm.id},on:{"update:dialog":_vm.onClose,"update":_vm.onUpdate}})}
var staticRenderFns = []

export { render, staticRenderFns }